/**
 * DocumentPreviewDialog
 * Shared dialog for previewing uploaded documents (images, PDFs).
 *
 * Usage:
 *   const docActions = useDocumentActions();
 *   <DocumentPreviewDialog {...docActions} />
 *
 * Props come directly from the useDocumentActions hook.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import DocumentPreviewPane from './DocumentPreviewPane';

export default function DocumentPreviewDialog({
  previewOpen,
  previewUrl,
  previewType,
  previewDocId,
  closePreview,
  downloadDocument,
}) {
  return (
    <Dialog open={!!previewOpen} onClose={closePreview} maxWidth="md" fullWidth>
      <DialogTitle>Document Preview</DialogTitle>
      <DialogContent>
        <DocumentPreviewPane
          previewUrl={previewUrl}
          previewType={previewType}
          previewDocId={previewDocId}
          downloadDocument={downloadDocument}
          height={600}
          minHeight={500}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closePreview}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
